import { getRequest, postRequest } from "../../../api/api";

export function getPreInvestmentScreeningQuestions(callbackResponse) {
    return getRequest(
        'api/v1/wallet/fetch-pre-screening-options',
        null,
        callbackResponse
    );
};

export function postSubmitPreInvestmentScreening(values, callbackResponse, callbackError) {
    return postRequest(
        'api/v1/wallet/save-pre-screening',
        null,
        values,
        callbackResponse,
        callbackError
    );
};